<div #map class="h-100" [class.drawing-disabled]="!isDrawingEnabled" [qpointLoading]="loading()">
  <div [id]="controlPdfLayerId" class="control-pdf-layer">
    <div class="control-pdf-layer--header">
      <h3>{{ controlTextConfig?.controlLayersTitle }}</h3>
      <qpoint-icon icon="close"></qpoint-icon>
    </div>
    <div class="control-pdf-layer--content" [qpointLoading]="loading()">
      <ng-container *ngIf="layers()">
        <div class="d-flex flex-row justify-content-between align-items-center">
          <b class="toggle-all">{{ controlTextConfig?.controlLayerAllLayersToggle }}</b>
          <qpoint-icon [class.disabled]="!allLayersVisible()" (click)="setLayerVisbilityAll()"
                       [icon]="allLayersVisible() ? 'eye' : 'eye-slash'"></qpoint-icon>
        </div>
        <ng-container *ngFor="let kv of layers() | keyvalue">
          <div class="d-flex flex-row justify-content-between align-items-center"
               [class.entry-disabled]="!kv?.value?.visible">
            <b class="text-truncate" qpointShowIfTruncated [ngbTooltip]="kv?.value?.name">{{ kv?.value?.name }}</b>
            <qpoint-icon [class.disabled]="!kv.value.visible" (click)="setLayerVisibility(kv.key, !kv.value.visible)"
                         [icon]="kv?.value?.visible ? 'eye' : 'eye-slash'"></qpoint-icon>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <div [id]="controlPaginationId" class="control-pagination" style="visibility: collapse; position: absolute">
    <div class="d-flex flex-row control-pagination--items">
      <div class="d-flex justify-content-center align-items-center" (click)="showPage(i)"
           *ngFor="let page of mappedPages(); index as i">
        <fa-layers [fixedWidth]="false" [class.item-active]="i === selectedIndex()"
                   [class.has-polygon]="page.hasPolygon">
          <fa-icon [icon]="[page.hasPolygon ? 'fas' : 'far', 'page']" size="2x"></fa-icon>
          <fa-layers-text [content]="''+(i + 1)" [transform]="i + 1 > 9 ? 'shrink-1' : null"></fa-layers-text>
        </fa-layers>
      </div>
    </div>
  </div>

  <qpoint-scale-dialog (measureScaleClicked)="handleScaleMeasure()"
                       (cancelClicked)="handleScaleCancel()" [textConfig]="scaleDialogTextConfig" [data]="scale()"
                       (submitMeasurements)="handleScaleChange($event)"></qpoint-scale-dialog>
</div>

<svg>
  <defs>
    <pattern id="diagonalHatch" width="5" height="5" patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse">
      <rect width="100%" height="100%" fill="#8993F8" fillOpacity="0.2"></rect>
      <line x1="0" y1="0" x2="0" y2="10" style="stroke:#0718b8; stroke-width:1;"/>
    </pattern>
  </defs>
</svg>

